const header = (gsap, ScrollTrigger) => {
    
  /***************************************************************
    TOGGLE CLASS FOR STICKY HEADER
  ***************************************************************/
  
  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('#header').outerHeight();
  var $globalHeader = $('body:not(.takeover) #header');

  $(window).scroll(function(event){
    didScroll = true;
  });

  setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
  }, 250);

  function hasScrolled() {
      var st = $(window).scrollTop();
      
      // Make sure they scroll more than delta
      if(Math.abs(lastScrollTop - st) <= delta)
          return;
      
      if (st > lastScrollTop){
        $globalHeader.addClass('has--scrolled');
      }
      
      if (st < 5){
        $globalHeader.removeClass('has--scrolled');
      }
      
      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      //if (st > lastScrollTop && st > navbarHeight){
      //    // Scroll Down
      //    if (!$globalHeader.hasClass('tucked')) {
      //      $globalHeader.addClass('tucked');
      //    }
      //} else {
      //    // Scroll Up
      //    if(st + $(window).height() < $(document).height()) {
      //      if ($globalHeader.hasClass('tucked')) {
      //        $globalHeader.removeClass('tucked');
      //      }
      //    }
      //}

      lastScrollTop = st;
  }
  
  //ScrollTrigger.create({
  //  start: 'top -50px',
  //  end: 99999,
  //  toggleClass: {className: 'has--scrolled', targets: '#header'},
  //  onUpdate: (self) => {
  //    if (self.direction === -1) {
  //      setTimeout(() => {
  //        if ($('#header').hasClass('tucked')) {
  //          $('#header').removeClass('tucked');
  //        }
  //      }, 600);
  //    } else {
  //      if (!$('#header').hasClass('tucked')) {
  //        $('#header').addClass('tucked');
  //      }
  //    }
  //  }
  //});

  /***************************************************************
    JUMBLE TEXT IN TOP NAV ON HOVER
  ***************************************************************/
 
  //function checkWidth(x) {
  //  if (x.matches) { // If media query matches
      
  //    //const $topNavItems = $('.site-top-level nav>ul>li>a span');

  //    //$topNavItems.each(function() {

  //    //  const $this = $(this);
  //    //  const $container = $this.parent().parent();
  //    //  const initWidth = $this.parent().outerWidth();
  //    //  const originalText = $this.text();

  //    //  $container.width(initWidth);

  //    //  $container.on('mouseenter', function() {
  //    //    gsap.to($this, {duration: 0.6, scrambleText:{text: originalText, chars: '$%&$#@?+-', speed: 2}}); 
  //    //  })

  //    //});
      
  //  } else {
      
  //    const $topNavItems = $('.site-top-level li'); 
      
  //    $topNavItems.attr('style', '');
      
  //  }
    
  //}

  //var x = window.matchMedia("(min-width: 62rem)")
  //checkWidth(x)
  //x.addListener(checkWidth)
     
}

export {
  header
};
